import { BillingInterval } from "../../../index";

interface BillingCycleConstructorProps {
	frequency: number;
	interval: BillingInterval;
}

class BillingCycle {
	constructor(private _: BillingCycleConstructorProps) {}

	static yearly = (frequency: number = 1) => {
		return new BillingCycle({ frequency, interval: BillingInterval.YEAR });
	};

	static monthly = (frequency: number = 1) => {
		return new BillingCycle({ frequency, interval: BillingInterval.MONTH });
	};

	get frequency() {
		return this._.frequency;
	}

	get interval() {
		return this._.interval;
	}

	static fromJson(json: any) {
		return new BillingCycle({
			frequency: json?.frequency || 0,
			interval: json?.interval || BillingInterval.defaultValue,
		});
	}

	toPaddleBillingCycle() {
		return `${this.interval}:${this.frequency}`;
	}

	toJson() {
		const res = { frequency: this.frequency, interval: this.interval } as any;
		return res;
	}

	equals(other: BillingCycle) {
		return (
			this.frequency === other.frequency && this.interval === other.interval
		);
	}
}

export { BillingCycle };
